import { Injectable } from '@angular/core';
const FileSaver = require('file-saver');

import { DateHelper } from "../bundles/helpers.bundle";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';

@Injectable()
export class ExportServicecsv {

    constructor() { }

  public exportAsCsvFile(data: any[], filename: string): void {

      const replacer = (key, value) => value === null ? '' : value;
      const header = Object.keys(data[0]);
      let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    let date = new Date();
    const resultDate = DateHelper.getStringDate_MMDDYYYY(date);
      var blob = new Blob([csvArray], { type: 'text/csv' })
    FileSaver.saveAs(blob, filename + '_' + resultDate + ".csv");
    }

  

}
